export default __webpack_public_path__ + "media/flags/jm-bd7d859f.svg";